import { mixpanelApi } from './mixpanel';
import { gtmApi } from './gtm';
import { newRelicApi } from './newRelic';
let alreadyStarted = false;
const init = ({ newRelic }) => {
    if (alreadyStarted) {
        return;
    }
    newRelicApi.init(newRelic);
    mixpanelApi.init(process.env.REACT_APP_MIXPANEL_API_KEY);
    gtmApi.init(process.env.REACT_APP_GTM_ID);
    alreadyStarted = true;
};
const updateTracking = (track) => {
    mixpanelApi.updateTracking(track);
    gtmApi.updateTracking(track);
    newRelicApi.updateTracking(track);
};
const onLogin = (externalId) => {
    mixpanelApi.onLogin(externalId);
    gtmApi.onLogin(externalId);
    newRelicApi.onLogin(externalId);
    register({ externalId: externalId });
};
const onLogout = () => {
    mixpanelApi.onLogout();
    gtmApi.onLogout();
    newRelicApi.onLogout();
    register({ externalId: null });
};
const userChanged = (externalId) => {
    if (externalId) {
        onLogin(externalId);
    }
    else {
        onLogout();
    }
};
const event = (eventOrName, properties = {}) => {
    let eventName;
    if (typeof eventOrName === 'string') {
        eventName = eventOrName;
    }
    else {
        eventName = [eventOrName.category, eventOrName.name].filter((value) => !!value).join('_');
    }
    mixpanelApi.event(eventName, properties);
    gtmApi.event(eventName, properties);
    newRelicApi.event(eventName, properties);
};
const register = (properties) => {
    mixpanelApi.register(properties);
    gtmApi.register(properties);
    newRelicApi.register(properties);
};
const setProperties = (properties) => {
    mixpanelApi.setProperties(properties);
    gtmApi.setProperties(properties);
    newRelicApi.setProperties(properties);
};
export const analyticsApi = {
    init,
    updateTracking,
    onLogin,
    onLogout,
    userChanged,
    register,
    event,
    setProperties
};
//# sourceMappingURL=analytics.js.map